import { h } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/spinner/spinner.sss';

export default ({ class: className, ...props }) => (
	<svg class={joinClasses(s.spinner, className)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M10 1.625C11.6564 1.625 13.2756 2.11619 14.6529 3.03644C16.0302 3.9567 17.1036 5.2647 17.7375 6.79503C18.3714 8.32536 18.5372 10.0093 18.2141 11.6339C17.8909 13.2585 17.0933 14.7508 15.922 15.922C14.7508 17.0933 13.2585 17.8909 11.6339 18.2141C10.0093 18.5372 8.32536 18.3714 6.79503 17.7375C5.26469 17.1036 3.9567 16.0302 3.03644 14.6529C2.11619 13.2756 1.625 11.6564 1.625 10" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);